<template lang="pug">
  section.home-epic
    .wrapper
      .text
        h2 La nueva Ford Ranger 2019. Nuevos terrenos, igual de resistente.
        p Un test drive en medio de la cordillera de los Andes. Un clásico actualizado al 2019.
        .video
          iframe#vrudo.vrudo(src="//rudo.video/vod/bGrlm0" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen")
    img.img-cover(src="content/img-epic.jpg")

</template>

<script>
  // import VideoPlayer from './VideoPlayer'

  export default  {
    components: {
      // VideoPlayer
    },

}
</script>

<style scoped lang="scss">
  .img-cover{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .home-epic {
    position: relative;
    .wrapper{
      min-height: 460px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      padding: 1rem;
      position: relative;
      z-index: 2;
      background: linear-gradient(to right, #fff 40%, transparent 70%);
      @media (max-width: 700px){
        background: linear-gradient(to bottom, #fff 40%, transparent 70%);
        grid-template-columns: repeat(1, 1fr);
        padding-top: 2rem;
      }
      p{
        font-size: 0.9rem;
      }
    }
  }
  .video{
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 0;
    height: 0;
    iframe{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }


</style>
